<template>
  <v-app v-if="appView">
    <v-navigation-drawer v-if="router != '/' && router != '/paineis' && router != '/atendimento' && router != 'atendimentoPainel' && router != '/satisfacao' && router != '/satisfacaoForm'" v-model="drawer" dark clipped app>
      <v-list dense flat>
        <v-list-item-group>
          <v-list-group color="white"
                        v-model="grupoAgendamento"
                        active-class="primary"
                        multiple>

            <template v-slot:activator>
              <v-list-item-icon>
                <v-icon>mdi-calendar</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                Agendamento
              </v-list-item-content>
            </template>

            <v-list-item class="ml-6" v-can to="/preagendamento">
              <v-list-item-icon class="mr-2">
                <v-icon>mdi-calendar-edit</v-icon>
              </v-list-item-icon>
              <v-list-item-content>Agendamento</v-list-item-content>
            </v-list-item>

            <v-list-item class="ml-6" to="/agenda">
              <v-list-item-icon class="mr-2">
                <v-icon>mdi-calendar-month</v-icon>
              </v-list-item-icon>
              <v-list-item-content>Agenda</v-list-item-content>
            </v-list-item>

            <v-list-item class="ml-6" v-can to="/formas_de_trabalho">
              <v-list-item-icon class="mr-2">
                <v-icon>mdi-calendar-question</v-icon>
              </v-list-item-icon>
              <v-list-item-content>Formas de trabalho</v-list-item-content>
            </v-list-item>
            <v-list-item class="ml-6" v-can to="/limite">
              <v-list-item-icon class="mr-2">
                <v-icon>mdi-calendar-clock</v-icon>
              </v-list-item-icon>
              <v-list-item-content>Limite de lançamento</v-list-item-content>
            </v-list-item>

          </v-list-group>

          <v-list-group color="white"
                        v-model="grupoCertificacao"
                        active-class="primary"
                        multiple>

            <template v-slot:activator>
              <v-list-item-icon>
                <v-icon>mdi-check-all</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                Certificação
              </v-list-item-content>
            </template>

            <v-list-item class="ml-6" to="/certificacao">
              <v-list-item-icon class="mr-2">
                <v-icon>mdi-checkbox-marked-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>Certificar serviços</v-list-item-content>
            </v-list-item>

          </v-list-group>

          <!-- grupoNucleto -->

          <v-list-group v-can color="white"
                        v-model="grupoNucleo"
                        active-class="primary"
                        multiple>

            <template v-slot:activator>
              <v-list-item-icon>
                <v-icon>mdi-playlist-check</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                Núcleo
              </v-list-item-content>
            </template>

            <v-list-item class="ml-6" to="/nucleo">
              <v-list-item-icon class="mr-2">
                <v-icon>mdi-timeline-check-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>Núcleo de Produção</v-list-item-content>
            </v-list-item>

          </v-list-group>

          <!-- <v-list-group v-can color="white"
                        v-model="grupoFaturamento"
                        active-class="primary"
                        multiple>

            <template v-slot:activator>
              <v-list-item-icon>
                <v-icon>mdi-trending-up</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                Faturamento
              </v-list-item-content>
            </template>

            <v-list-item class="ml-6" to="/adiantamento/1">
              <v-list-item-icon class="mr-2">
                <v-icon>mdi-cash-clock</v-icon>
              </v-list-item-icon>
              <v-list-item-content>Adiantamento</v-list-item-content>
            </v-list-item>

            <v-list-item class="ml-6" to="/faturar/servicos/realizados">
              <v-list-item-icon class="mr-2">
                <v-icon>mdi-currency-usd</v-icon>
              </v-list-item-icon>
              <v-list-item-content>Faturar serviços</v-list-item-content>
            </v-list-item>

            <v-list-item class="ml-6" to="/retornobanco">
              <v-list-item-icon class="mr-2">
                <v-icon>mdi-currency-usd</v-icon>
              </v-list-item-icon>
              <v-list-item-content>Retorno do banco</v-list-item-content>
            </v-list-item>

            <v-list-item class="ml-6" to="/faturamento">
              <v-list-item-icon class="mr-2">
                <v-icon>mdi-sync</v-icon>
              </v-list-item-icon>
              <v-list-item-content>Serviços faturados</v-list-item-content>
            </v-list-item>

            <v-list-item class="ml-6" to="/faturas">
              <v-list-item-icon class="mr-2">
                <v-icon>mdi-credit-card-clock-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>Gerenciar faturas</v-list-item-content>
            </v-list-item>

          </v-list-group> -->

          <!-- <v-list-group v-can color="white"
                        v-model="grupoSebraetec"
                        active-class="primary"
                        multiple>

            <template v-slot:activator>
              <v-list-item-icon>
                <v-icon>mdi-trending-up</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                Sebraetec
              </v-list-item-content>
            </template>

            <v-list-item class="ml-6" to="/adiantamento/2">
              <v-list-item-icon class="mr-2">
                <v-icon>mdi-cash-clock</v-icon>
              </v-list-item-icon>
              <v-list-item-content>Adiantamento</v-list-item-content>
            </v-list-item>

            <v-list-item class="ml-6" to="/faturar/servicos/sebraetec">
              <v-list-item-icon class="mr-2">
                <v-icon>mdi-currency-usd</v-icon>
              </v-list-item-icon>
              <v-list-item-content>Faturar</v-list-item-content>
            </v-list-item>

            <v-list-item class="ml-6" to="/sebratec_agrupar">
              <v-list-item-icon class="mr-2">
                <v-icon>mdi-cash-clock</v-icon>
              </v-list-item-icon>
              <v-list-item-content>Agrupar</v-list-item-content>
            </v-list-item>

            <v-list-item class="ml-6" to="/sebratec_baixar">
              <v-list-item-icon class="mr-2">
                <v-icon>mdi-cash-clock</v-icon>
              </v-list-item-icon>
              <v-list-item-content>Baixar</v-list-item-content>
            </v-list-item>

          </v-list-group> -->

          <v-list-group color="white"
                        active-class="primary"
                        multiple>

            <template v-slot:activator>
              <v-list-item-icon>
                <v-icon>mdi-earth</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                Área pública
              </v-list-item-content>
            </template>

            <v-list-item class="ml-6" to="/contratos">
              <v-list-item-icon class="mr-2">
                <v-icon>mdi-text-box-search</v-icon>
              </v-list-item-icon>
              <v-list-item-content>Contratos</v-list-item-content>
            </v-list-item>

            <v-list-item class="ml-6" to="/contratos_abertos">
              <v-list-item-icon class="mr-2">
                <v-icon>mdi-new-box</v-icon>
              </v-list-item-icon>
              <v-list-item-content>Novos termos</v-list-item-content>
            </v-list-item>

            <v-list-item class="ml-6" to="/dashboard">
              <v-list-item-icon class="mr-2">
                <v-icon>mdi-view-dashboard</v-icon>
              </v-list-item-icon>
              <v-list-item-content>Dashboard</v-list-item-content>
            </v-list-item>

            <v-list-item class="ml-6" to="/tutoriais">
              <v-list-item-icon class="mr-2">
                <v-icon>mdi-cast-education</v-icon>
              </v-list-item-icon>
              <v-list-item-content>Tutoriais</v-list-item-content>
            </v-list-item>

          </v-list-group>

        </v-list-item-group>

          <!-- <v-list-item to="/etiquetas">
            <v-list-item-icon>
              <v-icon>mdi-bookmark</v-icon>
            </v-list-item-icon>
            <v-list-item-content>Etiquetas</v-list-item-content>
          </v-list-item> -->

      </v-list>
    </v-navigation-drawer>

    <v-app-bar v-if="router != '/paineis' && router != '/atendimento' && router != 'atendimentoPainel'  && router != '/satisfacao' && router != '/satisfacaoForm'" color="primary" dense dark clipped-left app>
      <v-app-bar-nav-icon v-if="router != '/'" @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>SESI - Marcações</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <!-- <v-autocomplete @change="getIdUnidade($event)" v-if="this.router != '/' && usuario != null" v-model="unidadeSelecionada" class="mt-2" prepend-icon="mdi-home-city" :items="unidadesList" item-text="Unidade" item-value="IdUnidade"></v-autocomplete> -->
        <v-btn v-if="this.router != '/' && usuario != null" text dark>{{usuario.Usuario.split(' ')[0]}}</v-btn>
        <v-btn v-if="this.router != '/'" @click="logout()" icon>
          <v-icon>mdi-exit-to-app</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-app-bar>

    <v-main class="blue-grey lighten-5">
      <router-view :key="$route.path"></router-view>
    </v-main>
    <AlertSystem :snackbar="system.snackbar"></AlertSystem>

    <v-dialog persistent width="25%" v-model="isOffline">
      <v-card dark :loading="isOffline">
        <v-card-title>
          <v-icon left>mdi-access-point-network-off</v-icon> off-line
        </v-card-title>
        <v-card-text>
          Você está sem internet.
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-app>
</template>

<script>
import AlertSystem from "./components/AlertSystem.vue";
export default {
  name: "App",
  components: {
    AlertSystem,
  },
  data: () => ({
    system: {
      snackbar: {},
    },
    grupoAgendamento: [],
    grupoCertificacao: [],
    grupoNucleo: [],
    grupoFaturamento: [],
    grupoSebraetec: [],
    appView: true,
    router: "",
    drawer: true,
    perfis: "",
    usuario: null,
    unidadesList: [],
    unidadeSelecionada: ''
  }),
  methods: {
    adiantamento() {
      window.location.reload()
    },
    getUnidades () {
      this.axios('unidades').then(res => {
        this.unidadesList = res.data
        this.unidadeSelecionada = this.unidadesList[0].IdUnidade
        this.getIdUnidade(this.unidadesList[0].IdUnidade)
      })
    },
    getIdUnidade ($IdUnidade) {
      this.$store.commit('setIdUnidade', $IdUnidade)
    },
    checkAccess() {


      if(this.router === '/paineis' || this.router === '/satisfacao' || this.router === '/satisfacaoForm' || this.router === '/atendimento' || this.router === '/atendimentoPainel'){
        return true
      }

      if (this.router !== "/") {
        this.axios("/usuarios")
            .then((res) => {
              this.usuario = res.data;
            })
            .catch((e) => {
              this.appView = false
              location.href = "/";
              this.system.snackbar = {
                snackbar: true,
                text: e.response,
                color: "red",
              };
            });
      }
    },
    logout() {
      this.axios
          .post("auth/logout")
          .then(() => {
            location.href = "/";
          })
          .catch((e) => {
            this.system.snackbar = {
              snackbar: true,
              text: e.response,
              color: "red",
            };
          });
    },
  },
  mounted() {
    this.router = this.$router.history.current.path;
    this.checkAccess();
    this.getUnidades();
  },
};
</script>
